// extracted by mini-css-extract-plugin
export var hiddenButAccessible = "_redotech-redo-customer-portal-app-src-login-header-hidden-but-accessible";
export var logo = "_redotech-redo-customer-portal-app-src-login-header-logo";